import React from 'react';

import { ZonedDate } from '@eika-infrastruktur/date';
import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { CalendarConfig } from '../types';

export interface CalendarViewHeaderProps {
    calendar: CalendarConfig;
    onNavigate: (v: ZonedDate) => void;
}

const CalendarViewHeader = ({ calendar, onNavigate }: CalendarViewHeaderProps): JSX.Element => {
    return (
        <div className="sgw-calendar__view-header">
            <div className="sgw-calendar__view-header-left">
                {!!calendar.previousMonth && (
                    <>
                        <IconButton
                            tabIndex={0}
                            className="sgw-calendar__view-header-table-arrow"
                            icon={IconTypes.PIL_VENSTRE}
                            onClick={() => {
                                if (calendar.previousMonth) {
                                    onNavigate(calendar.previousMonth.zonedDate);
                                }
                            }}
                            screenReaderText={calendar.previousMonth?.aria ?? ''}
                        />
                        <IconButton
                            tabIndex={0}
                            className="sgw-calendar__view-header-list-arrow"
                            icon={IconTypes.LITEN_PIL_VENSTRE}
                            screenReaderText={calendar.previousMonth?.aria ?? ''}
                            onClick={() => {
                                if (calendar.previousMonth) {
                                    onNavigate(calendar.previousMonth.zonedDate);
                                }
                            }}
                        />
                    </>
                )}
            </div>

            <div className="sgw-calendar__view-header-center">
                <span className="sgw-calendar__view-header-center__text" aria-hidden="true">
                    {calendar.title.text}
                </span>
                <span
                    className="sgw-calendar__view-header-center__text_font-scale-large"
                    aria-hidden="true"
                >{`${calendar.title.fontLargeScale}`}</span>
            </div>

            <div className="sgw-calendar__view-header-right">
                {!!calendar.nextMonth && (
                    <>
                        <IconButton
                            tabIndex={0}
                            className="sgw-calendar__view-header-table-arrow"
                            icon={IconTypes.PIL_HOEYRE}
                            screenReaderText={calendar.nextMonth?.aria ?? ''}
                            onClick={() => {
                                if (calendar.nextMonth) {
                                    onNavigate(calendar.nextMonth.zonedDate);
                                }
                            }}
                        />
                        <IconButton
                            tabIndex={0}
                            className="sgw-calendar__view-header-list-arrow"
                            icon={IconTypes.LITEN_PIL_HOEYRE}
                            screenReaderText={calendar.nextMonth?.aria ?? ''}
                            onClick={() => {
                                if (calendar.nextMonth) {
                                    onNavigate(calendar.nextMonth.zonedDate);
                                }
                            }}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default CalendarViewHeader;
